import { lazy } from 'react';

const Profile = lazy(() => import('./ProcessorProfilePage'));

const ProcessorProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/profile',
      element: <Profile />,
    },
  ],
};

export default ProcessorProfileConfig;
